import { render, staticRenderFns } from "./Changetovar.vue?vue&type=template&id=9bb7d460&"
import script from "./Changetovar.vue?vue&type=script&lang=js&"
export * from "./Changetovar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports